var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWheelchair = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "wheelchair_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#wheelchair_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20.053 10.027a2.9 2.9 0 0 1-2.126-.887 2.9 2.9 0 0 1-.887-2.127 2.9 2.9 0 0 1 .887-2.126A2.9 2.9 0 0 1 20.053 4a2.9 2.9 0 0 1 2.127.887 2.9 2.9 0 0 1 .887 2.126 2.9 2.9 0 0 1-.887 2.127 2.9 2.9 0 0 1-2.127.887ZM28.427 36v-8.24h-11.36V14.987c0-.827.29-1.531.873-2.114A2.878 2.878 0 0 1 20.053 12c.623 0 1.154.127 1.594.38.44.253.944.713 1.513 1.38 1.235 1.458 2.495 2.589 3.78 3.393 1.284.805 2.704 1.23 4.26 1.274v2.666c-1.378 0-2.787-.324-4.227-.973a17.384 17.384 0 0 1-4.013-2.52v6.72h8.133V36h-2.666Zm-11.734 0c-2.213 0-4.082-.762-5.606-2.287C9.562 32.19 8.8 30.32 8.8 28.107c0-1.85.642-3.53 1.927-5.04 1.284-1.511 2.953-2.41 5.006-2.694v2.72c-1.27.213-2.295.807-3.073 1.78s-1.167 2.051-1.167 3.234c0 1.475.498 2.715 1.494 3.72.995 1.004 2.23 1.506 3.706 1.506 1.183 0 2.265-.389 3.247-1.166.982-.778 1.571-1.803 1.767-3.074h2.72c-.267 2.036-1.16 3.696-2.68 4.98C20.227 35.358 18.542 36 16.693 36Z"
}))));
export default SvgWheelchair;